import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import appEn from "./en/common.json";
import appKO from "./ko/common.json";
import { LANGUAGE } from "@root/constants";
import { getInitialLanguage } from "@root/utils/change-language";

i18next
  // learn more: https://github.com/i18next/i18next-http-backend
  .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    fallbackLng: LANGUAGE.KOREAN.toLocaleLowerCase(),
    lng: getInitialLanguage(), // Read from localStorage on app startup
    // fallbackLng: LANGUAGE.ENGLISH.toLocaleLowerCase(),
    // lng: LANGUAGE.ENGLISH.toLocaleLowerCase(),
    debug: true,
    interpolation: {},
    resources: {
      en: {
        common: appEn,
      },
      ko: {
        common: appKO,
      },
    },
    react: { useSuspense: false },
    ns: ["common"],
    defaultNS: "common",
  });

export default i18next;
